<template>
    <div>

     <v-container>
     		<!-- Form -->
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-form v-model="valid" ref="form" lazy-validation>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>							 
							
                <v-flex xs12 sm4 md6>
								 <v-text-field 
                                 label="Version No" 
                                 v-model="formSchema.version_no" :rules="[v => !!v || 'Field is required']" 
                                 required
                                 >
                                 </v-text-field>
							</v-flex>
              <v-flex xs12 sm4 md6>
              <v-text-field 
                            label="Type of Procurement" 
                            v-model="formSchema.type" :rules="[v => !!v || 'Field is required']" 
                            required
                            >
                            </v-text-field>
							</v-flex>
              
              <v-flex xs12 sm4 md6>
								 <v-text-field 
                                 label="Procurement Method" 
                                 v-model="formSchema.method" :rules="[v => !!v || 'Field is required']" 
                                 required
                                 >
                                 </v-text-field>
							</v-flex>

              <v-flex xs12 sm4 md6>
								 <v-text-field 
                                 label="Thresholds (Estimated Cost Of The)" 
                                 v-model="formSchema.cost" :rules="[v => !!v || 'Field is required']" 
                                 required
                                 >
                  </v-text-field>
							</v-flex>
                            <v-flex xs12 sm4 md6>
								 <v-text-field 
                                 label="Remarks" 
                                 v-model="formSchema.remark" :rules="[v => !!v || 'Field is required']" 
                                 required
                                 >
                                 </v-text-field>
							</v-flex>
                            <v-flex xs12 sm6 md4>	
                                <v-checkbox v-model="formSchema.is_active" label="Active" :value="isActiveVal"></v-checkbox>
                            </v-flex>
						</v-layout>
	                </v-container>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="success" @click.native="validateBeforeSubmit">{{btnTitle}}</v-btn>
					<v-btn color="error"  @click.native="reset">Reset</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
		<!-- /Form -->  
     </v-container>
      
    </div>
</template>

<script>
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import Axios from 'axios'
export default {
    props:['formSchema'],
    data: () => ({
      valid: true,     
      isActiveVal: 0
    }),

    computed: {
      formTitle () {
        return this.formSchema.id > 0 ? 'Update Thresholds' : 'New Thresholds'
      },
      btnTitle () {
        return this.formSchema.id > 0 ? 'Update' : 'Save'
      },
    },

    created () { },
   
    methods: {

      validateBeforeSubmit(e) {
        var formSchema = this.formSchema
        var root = this

        if (this.$refs.form.validate()) {
          if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(this.formSchema, 'thresholds').then(res => {
                let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status
              };
              this.close(actionData);
            });
          }
          else
          {            
            commonService.insertFormData(this.formSchema, 'thresholds').then(res => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status
              };
              this.close(actionData);
            });
          }
        }  
      },

      close(data){
        if(data.status == 1)
      		{
				 this.$refs.form.reset();
				 }				
				this.$emit('emitCloseModal', data)
      },

      reset() {
      if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    },

    },
}
</script>



// WEBPACK FOOTER //
// src/components/procurement/thresholds/thresholds_form.vue